"use client"

import { motion } from "framer-motion"
import { FaStar, FaStarHalf } from "react-icons/fa"

const ResenasBufete = ({ resenas = [], rating = 0 }) => { // Valor por defecto para resenas y rating
  const renderStars = (rating) => {
    const stars = []
    const fullStars = Math.floor(rating)
    const hasHalfStar = rating % 1 !== 0

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`star-${i}`} className="text-yellow-400" />)
    }

    if (hasHalfStar) {
      stars.push(<FaStarHalf key="half-star" className="text-yellow-400" />)
    }

    const remainingStars = 5 - Math.ceil(rating)
    for (let i = 0; i < remainingStars; i++) {
      stars.push(<FaStar key={`empty-star-${i}`} className="text-gray-300" />)
    }

    return stars
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="space-y-8"
    >
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
          <div>
            <h2 className="text-2xl font-bold mb-2">Valoraciones y Reseñas</h2>
            <div className="flex items-center space-x-2">
              <div className="flex">{renderStars(rating)}</div>
              <span className="text-lg font-semibold">{rating}</span>
              <span className="text-gray-500">({resenas.length} reseñas)</span>
            </div>
          </div>

          <button className="mt-4 md:mt-0 px-6 py-2 bg-[var(--gold)] text-white rounded-lg hover:bg-[var(--gold-dark)] transition-colors">
            Escribir reseña
          </button>
        </div>

        <div className="space-y-6">
          {resenas.length > 0 ? (
            resenas.map((resena, index) => (
              <motion.div
                key={resena.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="border-b border-gray-200 last:border-0 pb-6 last:pb-0"
              >
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <h3 className="font-semibold">{resena.author}</h3>
                    <div className="flex space-x-1">{renderStars(resena.rating)}</div>
                  </div>
                  <span className="text-sm text-gray-500">{new Date(resena.date).toLocaleDateString()}</span>
                </div>
                <p className="text-gray-600 mt-2">{resena.comment}</p>
              </motion.div>
            ))
          ) : (
            <p>No hay reseñas disponibles.</p> // Mensaje alternativo si no hay reseñas
          )}
        </div>
      </div>
    </motion.div>
  )
}

export default ResenasBufete
